require('./bootstrap');

/**
 * Arquivo JavaScript principal.
 * A partir daqui são incluídas todas as dependências.
 */
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vuelidate from 'vuelidate'
import VueProgressBar from 'vue-progressbar'


import Pbh from '@prodabel/piweb-lib-vue';

import router from './routes';
import store from './stores';
import helpers from './helpers';
import filters from './filters';
import Root from './pages/paginaRaiz.vue';

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Pbh, {
    merge: {
        filters,
        helpers
    },
    store
});
const options = {
    color: '#28a745',
    failedColor: '#874b4b',
    thickness: '5px',
  }
  
Vue.use(VueProgressBar, options)
  
library.add(faCircle)
library.add(faFilePdf)
Vue.component('font-awesome-icon', FontAwesomeIcon)

helpers.getEnv().then((dados)=>{    
    Vue.prototype.$env = dados;
    new Vue({
        data() {
            return {
                carregando: false,
            }
        },
        store,
        router,
        render: h => h(Root),
    }).$mount('#app')
});